(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-owner-stories-collection"]) return;
  try {
    
window.addEventListener('load', () => {
	const loadMore = document.querySelector('#loadMore');
    const blockEls = document.querySelectorAll('.storyBlock__list .storyBlock__item');
    const blockElsLength = blockEls.length;
	const blocksChunkSize = loadMore.dataset.chunkSize;
    
    if (blockElsLength > blocksChunkSize) {
		blockEls.forEach((el, index) => {
			if ((index + 1) > blocksChunkSize) {
				el.style.display = "none";
				el.setAttribute('data-active', 'false');
			}
		});
	}
});

document.querySelector('#loadMore').addEventListener('click', function() {
	const blocksLength = JSON.parse(this.dataset.length);
	const blocksChunkSize = JSON.parse(this.dataset.chunkSize);
    const blocksCurrentChunkLength = JSON.parse(this.dataset.chunkActive);
	const blockEls = document.querySelectorAll('.storyBlock__list .storyBlock__item');
	const blockElsLength = blockEls.length;
	
	// add more items to the active chunk length
	const newActiveChunkLength = blocksCurrentChunkLength + blocksChunkSize;
	this.setAttribute('data-chunk-active', newActiveChunkLength);

	if (blocksLength === newActiveChunkLength || blockElsLength < newActiveChunkLength) {
		this.style.display = 'none';
	}

	 blockEls.forEach((el, index) => {
        if (index < newActiveChunkLength) {
            el.style.display = "block";
            el.setAttribute('data-active', 'true');
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
